import React from 'react';
import EmptySection from 'components/lib/EmptySection';
import Accordion from '../lib/Accordion';
import Carousel from '../lib/Carousel';
import FlipCard from '../lib/FlipCard';
import FullPageText from '../lib/FullPageText';
import Multichoice from '../lib/Multichoice';
import MultichoiceImage from 'components/lib/MultichoiceImage';
import Sortation from '../lib/Sortation';
import Matching from '../lib/Matching';
import TextAndImage from '../lib/TextAndImage';
import HotSpot from '../lib/HotSpot';
import FiveStarRating from '../lib/FiveStarRating';
import ResultsPage from '../lib/ResultsPage';
import Slider from 'components/lib/Slider';
import ClickAndReveal from '../lib/ClickAndReveal';
import SelectOptions from 'components/lib/SelectOptions';
import TopicPortal from '../lib/TopicPortal';
import TextEntry from 'components/lib/TextEntry';
import TextEntryVariable from 'components/lib/TextEntryVariable';
import TextEntryQuiz from 'components/lib/TextEntryQuiz';
import ContentCards from 'components/lib/ContentCard';
import Assessment from '../lib/Assessment';
import AssessmentIntroduction from '../lib/AssessmentIntroduction';
import AssessmentQuestion from '../lib/AssessmentQuestion';
import AssessmentResults from '../lib/AssessmentResults';
import Certificate from 'components/lib/Certificate';
import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { State } from 'store/store';
import { css } from 'emotion';

const InteractionComponents = {
  Accordion,
  Carousel,
  FlipCard,
  FullPageText,
  Multichoice,
  MultichoiceImage,
  Sortation,
  Slider,
  Matching,
  TextAndImage,
  HotSpot,
  FiveStarRating,
  TextEntry,
  TextEntryVariable,
  ResultsPage,
  ClickAndReveal,
  SelectOptions,
  TopicPortal,
  ContentCards,
  Assessment,
  AssessmentIntroduction,
  AssessmentQuestion,
  AssessmentResults,
  TextEntryQuiz,
  Certificate,
};

const getInteractionsSeen = createSelector(
  (state: any) => state.interactionsSeen,
  interactionsSeen => interactionsSeen
);

const Interactions = ({ interactions }) => {
  const { buttonBackgroundColor, buttonTextColor } = useSelector(
    (state: any) => {
      return state.theme;
    }
  );

  const { exitComplete } = useSelector((state: State) => {
    return {
      exitComplete: state.exitComplete,
    };
  });

  if (!interactions.length) {
    return <EmptySection />;
  }

  const interactionsSeen = useSelector(getInteractionsSeen);

  const addNextInteractionToInteractionsSeen = interactions.filter(
    (i: any, index) => {
      // return true;
      return index === 0 || interactionsSeen.includes(i.id);
    }
  );

  if (addNextInteractionToInteractionsSeen.length !== interactions.length) {
    addNextInteractionToInteractionsSeen.push(
      interactions[addNextInteractionToInteractionsSeen.length]
    );
  }

  if (exitComplete) {
    console.log('You may now closse your browser window');

    return (
      <div
        style={{
          width: '100%',
          height: 'calc(100vh - 70px)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <div style={{ textAlign: 'center' }}>
          <h3 style={{ margin: '16px 16px 36px' }}>
            You may now close your browser window
          </h3>
          <button
            css={css`
              position: relative;
              justify-content: center;
              align-items: center;
              width: 230px;
              min-height: 48px !important;
              word-break: break-word;
              line-height: 1.2;
              cursor: pointer;
              outline: none;
              background: ${buttonBackgroundColor} !important ;
              border: 1px solid ${buttonBackgroundColor} !important ;
              color: ${buttonTextColor} !important ;
              font-family: inherit !important;
              font-size: 14px;
              font-weight: 400 !important;
              font-style: normal;
              box-shadow: 0 0 12px 3px rgba(0, 0, 0, 0.09);
              transition: background, border, color, opacity 0.2s;
              margin: 5px 10px;
              border-radius: 999px;
              &:hover {
                opacity: 0.45;
              }
            `}
            onClick={() => {
              setTimeout(() => {
                if (window.self === window.top) {
                  window.close();
                } else {
                  window?.top?.close();
                }
              }, 100);
            }}
          >
            Close
          </button>
        </div>
      </div>
    );
  }

  return addNextInteractionToInteractionsSeen.map((interaction, i) => {
    const { id } = interaction;
    const Interaction = InteractionComponents[interaction.meta.subType];

    // console.log(Interaction);

    return (
      <Interaction
        key={id}
        blockId={id}
        isOpen={i === 0}
        aria-label={`Interaction: ${interaction.props.name}`}
        sectionLabel={`Section ${i + 1}`}
        data={{
          ...interaction,
        }}
      />
    );
  });
};

export default Interactions;
